export const convertMillimetersToMeters = (millimeters: number): number => {
  return millimeters / 1000;
};
